import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { fetchNavigation } from '_redux/actioncreators/navigation';
import { fetchTranslations } from '_redux/actioncreators/translations';
import { TRANSLATIONS } from '_translations';

import Navigation from './navigation/Navigation';
import PageContainer from './pages/PageContainer';
import Leaderboard from './leaderboard/Leaderboard';
import Loader from './general/Loader';

class App extends Component {
  constructor(props) {
    super(props);

    props.fetchTranslations({ cultureCode: props.culture.cultureCode, keys: TRANSLATIONS });
    props.fetchNavigation({ cultureCode: props.culture.cultureCode });
  }

  render() {
    if (this.props.navigation.contentLoading === true || this.props.translations.isLoading === true) {
      return <Loader/>;
    }

    return (
      <Router>
        <React.Fragment>
          <Navigation culture={this.props.culture} navigation={this.props.navigation}></Navigation>

          <div className="main">
            <Switch>
              {this.renderRoutes()}
            </Switch>
            <Leaderboard cultureCode={this.props.culture.cultureCode}></Leaderboard>
          </div>
        </React.Fragment>
      </Router>
    );
  }

  renderRoutes() {
    if (this.props.navigation.contentLoading === true) {
      return null;
    }

    return this.props.navigation.content.navigationItems.map(this.renderRoute);
  }

  // eslint-disable-next-line
  renderRoute = (item, index) => {
    // const isExact = item.slug === '/';

    return <Route key={index} path={`/${this.props.culture.alias + item.slug}`} exact component={() =>
      <PageContainer cultureCode={this.props.culture.cultureCode} contentClassName={item.contentClassName} />}
    />;
  }
}

const mapStateToProps = state => ({
  navigation: state.app.navigation,
  translations: state.app.translations,
});

const mapDispatchToProps = dispatch => ({
  fetchNavigation: params => dispatch(fetchNavigation(params)),
  fetchTranslations: params => dispatch(fetchTranslations(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
